import { IPaymentDictionaryRejected } from '../../../actions/paymentDictionary/loadDictionaries'
import { IPaymentDictionaryStore } from '../index'

export default function(
  store: IPaymentDictionaryStore,
  action: IPaymentDictionaryRejected,
): IPaymentDictionaryStore {
  return {
    ...store,
    request: {
      ...store.request,
      errMessage: action.errMessage,
      isLoading: false,
    },
  }
}
